var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Graph Style/Line") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Graph-Style/Line",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,14 L0,0 L1,0 L1,13 L14,13 L14,14 L0,14 Z M13.2243936,1.59213413 C13.4423731,1.70498573 13.5423468,1.95591734 13.4727054,2.18251743 L13.4385384,2.26603471 L11.8673664,5.30084642 C11.7282995,5.56946237 11.39044,5.64878223 11.1487237,5.4890176 L11.079388,5.43386589 L9.984,4.396 L8.72320219,6.74026327 C8.58326505,7.0002452 8.25592359,7.07759056 8.01722278,6.92706485 L7.94131749,6.8683879 L6.878,5.874 L5.57041809,8.24317699 C5.50008849,8.37044777 5.37870721,8.45949287 5.2393101,8.48987698 L5.15377422,8.50090465 L3.904,8.553 L2.43438112,11.2738928 C2.31767182,11.4898315 2.0650024,11.585328 1.83967631,11.5116688 L1.7567797,11.4760223 C1.54084106,11.359313 1.44534453,11.1066435 1.51900374,10.8813175 L1.55465027,10.7984208 L3.16009042,7.82799306 C3.22988798,7.69885178 3.35202426,7.60825782 3.49264964,7.57736898 L3.57897277,7.56616955 L4.831,7.513 L6.31448498,4.82913668 C6.45629236,4.57251735 6.78134582,4.49767639 7.01835392,4.64753121 L7.09372354,4.70586375 L8.15,5.694 L9.41406001,3.34687328 C9.5545663,3.08583396 9.88373991,3.00913332 10.1224516,3.16158885 L10.1982888,3.2209561 L11.285,4.251 L12.550493,1.80627897 C12.677451,1.561052 12.9791666,1.46517609 13.2243936,1.59213413 Z",
    id: "Combined-Shape",
    fill: "#666666",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/Line.66835ffa03dcfee69f2e82d480cd28e9.svg";
export { ForwardRef as ReactComponent };